import { render, staticRenderFns } from "./ResourcePublishRequestActionsComponent.vue?vue&type=template&id=17cd29b2&scoped=true"
import script from "./ResourcePublishRequestActionsComponent.vue?vue&type=script&lang=js"
export * from "./ResourcePublishRequestActionsComponent.vue?vue&type=script&lang=js"
import style0 from "./ResourcePublishRequestActionsComponent.vue?vue&type=style&index=0&id=17cd29b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cd29b2",
  null
  
)

export default component.exports